import { useCallback, useEffect } from "react";
import { GridWrapper } from "../../../components";
import { CustodyBeneficiary, DivestTransactionTable, ProductSelection } from "../components";
import { InvestDivestErrorMessage } from "../components/ErrorMessages";
import { useInstruction } from "../contexts/InstructionContext";

const TransferOut = ({ instructionId }) => {
    const [{ fetchInvest, fetchDivest }, { investIsError, divestIsError }] = useInstruction();

    useEffect(() => {
        fetchInvest({ instructionId });
        fetchDivest({ instructionId });
    }, [fetchDivest, fetchInvest, instructionId]);

    const retry = useCallback(() => {
        fetchInvest({ instructionId });
        fetchDivest({ instructionId });
    }, [fetchDivest, fetchInvest, instructionId])

    if (investIsError || divestIsError)
        return <InvestDivestErrorMessage retry={retry} />

    return <GridWrapper>
        <ProductSelection
            changeOwner
            productLabel={"Transfer out:"}
        />
        <DivestTransactionTable isTransferOut />

        <CustodyBeneficiary />

    </GridWrapper>;
}

export default TransferOut;